// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ButtonDownload_buttonContainer__-KZJR","buttonIcon":"ButtonDownload_buttonIcon__lqDf4"};